import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { styled, alpha } from "@mui/material/styles";
import Menu from "@mui/material/Menu";
import AuthService from "../../HTTP/auth.service";
import { getCountryPurchasePremium } from "../../HTTP/payment";
import { isCountryPurchaseMarkerSubscription } from "../../Helper/countryPurchaseAccess";

const StyledMenu = styled((props) => (
	<Menu
		elevation={0}
		anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
		transformOrigin={{ vertical: "top", horizontal: "right" }}
		{...props}
	/>
))(({ theme }) => ({
	"& .MuiPaper-root": {
		borderRadius: 8,
		marginTop: theme.spacing(1),
		minWidth: 210,
		color: "#00D5F3",
		backgroundColor: "transparent",
		boxShadow:
			"rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
		"& .MuiMenu-list": {
			padding: "4px 0",
		},
		"& .MuiMenuItem-root": {
			"& .MuiSvgIcon-root": {
				fontSize: 25,
				color: "#00D5F3",
				backgroundColor: "transparent",
			},
			"&:active": {
				backgroundColor: alpha(
					theme.palette.primary.main,
					theme.palette.action.selectedOpacity
				),
			},
		},
	},
}));

const ProfileSelfActions = ({ user }) => {
	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);

	const localSubscription = (() => {
		try {
			return JSON.parse(localStorage.getItem("subscriptions") || "null");
		} catch (error) {
			return null;
		}
	})();
	const hasRealSubscription = Boolean(localSubscription) && !isCountryPurchaseMarkerSubscription(localSubscription);
	const [hasPremiumAccess, setHasPremiumAccess] = useState(hasRealSubscription);
	const [hasPurchasedCountries, setHasPurchasedCountries] = useState(false);

	useEffect(() => {
		let isMounted = true;

		const loadPremiumAccess = async () => {
			if (!user?.id || hasRealSubscription) return;

			try {
				const response = await getCountryPurchasePremium(user.id);
				if (isMounted && response?.has_country_purchase_premium === true) {
					setHasPurchasedCountries(true);
					setHasPremiumAccess(true);
				}
			} catch (error) {
				console.error("Impossible de vérifier l'accès premium acheté", error);
			}
		};

		loadPremiumAccess();
		return () => {
			isMounted = false;
		};
	}, [hasRealSubscription, user?.id]);

	const handleLogout = async () => {
		localStorage.removeItem("user");
		localStorage.removeItem("token");
		localStorage.removeItem("subscriptions");
		sessionStorage.setItem("initLang", "false");
		sessionStorage.removeItem("search_igo");
		await AuthService.disconnect(user.id);
		window.location.reload();
	};

	return (
		<div className="profileHeader-element md:ml-auto">
			<div className="list1">
				<Button
					id="demo-customized-button"
					aria-controls={open ? "demo-customized-menu" : undefined}
					aria-haspopup="true"
					aria-expanded={open ? "true" : undefined}
					variant="contained"
					disableElevation
					onClick={(event) => setAnchorEl(event.currentTarget)}
					endIcon={<KeyboardArrowDownIcon />}
					style={{ backgroundColor: "transparent", color: "#ffffff", fontSize: "15px", fontWeight: 700, position: "relative" }}
				>
					Mon compte
				</Button>
				<StyledMenu
					id="demo-customized-menu"
					MenuListProps={{ "aria-labelledby": "demo-customized-button" }}
					anchorEl={anchorEl}
					open={open}
					onClose={() => setAnchorEl(null)}
				>
					<ul className="ulflag">
						<li><button style={{ fontSize: 22, paddingTop: 6 }} onClick={handleLogout}> Déconnexion </button></li>
						<li><a href="/edit">Editer le profil</a></li>
						<li><a href="/profile/subscription">Voir son abonnement</a></li>
					</ul>
				</StyledMenu>
			</div>
			{(!hasRealSubscription || hasPurchasedCountries) && (
				<button onClick={() => window.location.href = "/purchase-countries"} className="btnpremm" style={{ color: "#000" }}>
					Acheter des pays
				</button>
			)}
			{hasPremiumAccess && (
				<button onClick={() => window.location.href = "/ai-tokens"} className="btnpremm m" style={{ color: "#000" }}>
					Acheter des tokens IA
				</button>
			)}
		</div>
	);
};

export default ProfileSelfActions;
